const ACCOUNT_TABS = ['convertNavConversions', 'convertNavSavings'];

export default ACCOUNT_TABS;
